import { Filter } from '@on3/ui-lib/components/Filter/Filter';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import { ArrowRight } from 'components/Svg/ArrowRight';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles from './TopHeader.module.scss';

const sortByOptions = [
  { label: 'Rating', value: 'rating' },
  { label: 'NIL Value', value: 'nilvalue' },
];

export const TopHeader = () => {
  const { formatHref } = useDynamicRoute();
  const router = useRouter();

  const { query } = router;
  const { orderby } = query;

  return (
    <div className={styles.block} data-sort-type={orderby || 'rating'}>
      <span data-name="rank">Rank</span>
      <span data-name="player">Player</span>

      <span aria-label="Position" data-name="position">
        Pos
      </span>

      <Link
        data-name="rating"
        href={formatHref({
          query: {
            orderby: undefined,
          },
        })}
      >
        Rating {!orderby && <ArrowRight />}
      </Link>
      <Link
        data-name="nil"
        href={formatHref({
          query: {
            orderby: 'nilvalue',
          },
        })}
      >
        NIL Value {orderby === 'nilvalue' && <ArrowRight />}
      </Link>

      <span data-name="player-status">Status</span>
      <div data-name="team-status">
        <span>Last Team</span>
        <span>New Team</span>
      </div>

      <div className={styles.mobileSort}>
        <span>Sort by:</span>
        <Filter
          name="orderby"
          navigate={(_, v) =>
            formatHref({
              query: {
                orderby: v === 'rating' ? undefined : v,
              },
            })
          }
          options={sortByOptions}
          value={String(orderby ? orderby : 'rating')}
        />
      </div>
    </div>
  );
};
